export const IDLE_TIMEOUT_DEFAULT_MINUTES = 20;
export const IDLE_TIMEOUT_MIN_MINUTES = 5;
export const IDLE_TIMEOUT_MAX_MINUTES = 120;
export const IDLE_TIMEOUT_STEP_MINUTES = 5;
